// extracted by mini-css-extract-plugin
export default {"Badge":"y0Hx2_xGdQuYIKrF_Cnw","badge":"YOpY7MuiI9JvB24nVp0j"};